import React, { Component } from "react";
import axios from "axios";
import {
  Modal,
  Button,
  Col,
  OverlayTrigger,
  Popover,
  Form,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileUpload,
  faUpload,
  faQuestionCircle,
  faQrcode,
} from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import QRCode from "qrcode.react";
import ReactMomentCountDown from "react-moment-countdown";
import momentPropTypes from "react-moment-proptypes";
const fechafutura = "2021-01-31 17:18:43";
export default class Adjunto extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      modalDocumentos: false,
      frm_descripcion_doc: "",
      frm_archivo: null,
      loading: false,
      codigo: "",
      caducidad: "",
    };
  }

  onFileChange = (event) => {
    this.setState({
      frm_archivo: event.target.files[0],
    });
  };

  sube_documento = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    let datosFormulario = new FormData();
    datosFormulario.append("archivo", this.state.frm_archivo);
    datosFormulario.append("descripcion", this.state.frm_descripcion_doc);
    datosFormulario.append("tipo", "jpg");
    datosFormulario.append("anexo_cve", this.props.formato);
    datosFormulario.append("fx_id", this.props.id);
    datosFormulario.append("ambito_id", this.props.ambito_id);
    datosFormulario.append("usuario_id", localStorage.id);
    datosFormulario.append("api_token", localStorage.api_token);

    let config = {};
    axios
      .post(
        "http://143.198.191.211/api/Documento/",
        datosFormulario,
        config
      )
      .then((res) => {
        this.closeModalDocumentos();
        toast.success(res.data.text, { autoClose: 1000 });
        //this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  ModalDocumentos = () => {
    this.setState({ modalDocumentos: true });
  };

  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  generaCodigo = () => {
    let config = {};
    let datos = {
      formato_cve: this.props.formato,
      fx_id: this.props.id,
      ambito_id: this.props.ambito_id,
      usuario_id: localStorage.id,
      api_token: localStorage.api_token,
    };
    axios
      .post(
        "http://143.198.191.211/api/CargaQRToken/",
        datos,
        config
      )
      .then((res) => {
        let dt = new Date();
        dt.setMinutes(dt.getMinutes() + 5);
        this.setState({
          codigo: res.data.codigo,
          caducidad: dt,
        });
      });
  };

  render() {
    return (
      <div>
        <ToastContainer />
        <button
          style={{ borderRadius: 0, marginLeft: -1 }}
          type="button"
          className="btn btn-outline-warning btn-sm"
          size="sm"
          onClick={this.ModalDocumentos}
          data-tip="Adjuntar Imagen o Archivo PDF"
        >
          <FontAwesomeIcon icon={faFileUpload} size="lg" />
        </button>

        <Modal //*******************************Modal para Documentos
          show={this.state.modalDocumentos}
          onHide={this.closeModalDocumentos}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Documentos</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body>
              <Form.Row>
                <Col xs="8">
                  <Form.Label>
                    Descripcion del Archivo:
                    <OverlayTrigger
                      trigger="focus"
                      placement="right"
                      overlay={
                        <Popover id="popover-basic">
                          <Popover.Title as="h3">Ayuda</Popover.Title>
                          <Popover.Content>
                            Ingrese un texto descriptivo del documento que se va
                            a subir.
                          </Popover.Content>
                        </Popover>
                      }
                    >
                      <Button variant="light">
                        <FontAwesomeIcon icon={faQuestionCircle} />
                      </Button>
                    </OverlayTrigger>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="frm_descripcion_doc"
                    onChange={this.onChangefrm_descripcion_doc}
                  />
                </Col>
                <Col xs="4">
                  Carga imagenes y archivos PDF con tu Celular
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={
                      <Popover id="popover-basic">
                        <Popover.Title as="h3">Ayuda</Popover.Title>
                        <Popover.Content>
                          Escanea con tu celular este codigo QR para que
                          agregues adjuntos a este registro, puedes hacerlo
                          desde la cámara o desde el almacenamiento de tu
                          teléfono, los archivos admitidos son imágenes y
                          documentos PDF.
                        </Popover.Content>
                      </Popover>
                    }
                  >
                    <Button variant="light">
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                  <br />
                  <br />
                  <center>
                    <Button onClick={this.generaCodigo}>
                      <FontAwesomeIcon icon={faQrcode} /> Generar Código
                    </Button>
                    {this.state.codigo != "" ? (
                      <div>
                        <QRCode
                          value={
                            "http://143.198.191.211/CargaQR/" +
                            this.state.codigo
                          }
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </center>
                </Col>
              </Form.Row>
              <Form.Row>
                <Col xs="12">
                  <br />
                  <label htmlFor="file-upload" className="custom-file-upload">
                    <FontAwesomeIcon icon={faUpload} /> Seleccionar Archivo PDF
                    o Imagen
                  </label>
                  <input
                    id="file-upload"
                    type="file"
                    onChange={this.onFileChange}
                    accept="image/png, image/jpeg, application/pdf"
                    className="btnSubir"
                  />
                </Col>
              </Form.Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.closeModalDocumentos}
              disabled={this.state.loading}
            >
              Cancelar
            </Button>
            <Button onClick={this.sube_documento} disabled={this.state.loading}>
              {this.state.loading ? "Subiendo adjunto..." : "Guardar Documento"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
